(() => {
  const elementName = 'ug-jp-spokesperson-gifts';
  if (customElements.get(elementName)) return;

  class SpokespersonGifts extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frames = Array.from(this.querySelectorAll('[data-campaign-frame]'));
      this.active = Math.max(0, this.frames.findIndex((frame) => frame.getAttribute('aria-hidden') === 'false'));
      this.interval = Math.max(2000, Math.min(10000, Number(this.dataset.interval) || 3000));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.selectedBlock = null;
      const signal = this.controller.signal;
      const sync = () => this.schedule();
      document.addEventListener('visibilitychange', sync, { signal });
      this.motion.addEventListener('change', sync, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const frame = this.frames.find((item) => item.dataset.blockId === event.detail?.blockId);
        if (!frame) return;
        this.selectedBlock = frame;
        this.preload();
        this.show(this.frames.indexOf(frame));
        this.schedule();
      }, { signal });
      document.addEventListener('shopify:block:deselect', (event) => {
        if (!this.contains(event.target)) return;
        if (this.selectedBlock?.dataset.blockId !== event.detail?.blockId) return;
        this.selectedBlock = null;
        this.schedule();
      }, { signal });
      this.frames.forEach((frame, index) => {
        frame.querySelector('img').addEventListener('load', () => {
          if (frame === this.selectedBlock) this.show(index);
          else this.recoverFrame();
        }, { signal });
        frame.querySelector('img').addEventListener('error', () => this.recoverFrame(), { signal });
      });
      this.recoverFrame();
      this.observer = new IntersectionObserver(([entry]) => {
        if (signal.aborted) return;
        this.visible = entry.isIntersecting;
        if (this.visible) this.preload();
        this.schedule();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }

    preload() {
      this.frames.forEach((frame) => { frame.querySelector('img').loading = 'eager'; });
    }

    ready(frame) {
      const image = frame.querySelector('img');
      return image.complete && image.naturalWidth > 0;
    }

    show(index) {
      if (!this.ready(this.frames[index])) return;
      this.active = index;
      this.frames.forEach((frame, position) => {
        frame.setAttribute('aria-hidden', String(position !== index));
      });
    }

    recoverFrame() {
      if (this.frames[this.active] && this.ready(this.frames[this.active])) return;
      const index = this.frames.findIndex((frame) => this.ready(frame));
      if (index >= 0) this.show(index);
    }

    schedule() {
      clearTimeout(this.timer);
      if (!this.controller || this.frames.length < 2 || this.dataset.autoplay === 'false' || this.hasAttribute('data-paused') || !this.visible || document.hidden || this.motion.matches || this.selectedBlock) return;
      this.timer = setTimeout(() => {
        for (let offset = 1; offset < this.frames.length; offset += 1) {
          const index = (this.active + offset) % this.frames.length;
          if (!this.ready(this.frames[index])) continue;
          this.show(index);
          break;
        }
        this.schedule();
      }, this.interval);
    }
  }

  customElements.define(elementName, SpokespersonGifts);
})();
